import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SidebarComponent } from './sidebar.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: SidebarComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class SidebarRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/sidebar/sidebar-routing.module.ts